import { useReportQueryBySearchParam } from './useReportQueryBySearchParam';
import { getQueryEqualValue, getQueryInValues } from '../utils';
import { useMemo } from 'react';

interface IUseGetQueryValues {
  fields: string[];
}
export const useGetQueryValues = ({ fields }: IUseGetQueryValues) => {
  const { query } = useReportQueryBySearchParam();

  const values = useMemo(() => {
    const values = fields.map((field) => getQueryEqualValue(query, field));
    return values;
  }, [query, fields]);

  return values;
};

export const useGetQueryInValues = ({ fields }: IUseGetQueryValues) => {
  const { query } = useReportQueryBySearchParam();

  const values = useMemo(() => {
    const values = fields.map((field) => getQueryInValues(query, field));
    return values;
  }, [query, fields]);

  return values;
};
